import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Box,
  Heading,
  AccordionIcon,
  HStack,
  Stack,
  useBreakpointValue,
  useDisclosure,
} from '@chakra-ui/react';
import ProductList from './ProductList';
import ProductGrid from './ProductGrid';
import { Switch } from '@chakra-ui/react';
import { Slider, SliderTrack, SliderFilledTrack, SliderThumb } from '@chakra-ui/react';
import { Button } from '@chakra-ui/react';
import ModalCashierStats from './ModalCashierStats';
import ModalOrderHistory from './ModalOrderHistory';

function Menu2CategoryAccordion({ menu, increment, decrement, product, isCashier, appSettings }) {
  const [showImages, setShowImages] = useState(true);
  const responsiveColumns = useBreakpointValue({ base: 2, sm: 4, lg: 4, xl: 5 });
  const [columns, setColumns] = useState(responsiveColumns);
  const [showPrices, setShowPrices] = useState(true);
  const [showAvailability, setShowAvailability] = useState(true);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isHistoryOpen, onOpen: onHistoryOpen, onClose: onHistoryClose } = useDisclosure();
  
  // Categorie dinamiche come in Menu.js
  const uniqueCategories = [...new Set(menu.products.map((p) => p.category))];
  const categories = [];
  if (menu.combos.length) {
    // categories.push({ title: 'Menù', _cat: 'combo', component: ComboList, array: menu.combos });
    categories.push({ title: 'Menù', _cat: 'combo', array: menu.combos });
  }
  uniqueCategories.forEach((_category) => {
    categories.push({
      title: _category.charAt(0).toUpperCase() + _category.slice(1),
      _cat: _category,
      component: ProductList,
      array: menu.products.filter((p) => p.category === _category),
    });
  });

  useEffect(() => {
    setColumns(responsiveColumns);
  }, [responsiveColumns]);

  // CASSA: griglia compatta
  if (isCashier) {

    return (
      <>
        <Stack direction={{ base: 'column', md: 'row' }} align='center' mb={2} spacing={5}>
          <HStack
            w={{ base: '100%', md: 'auto' }}
            justifyContent={'space-between'}
            alignItems={{ base: 'flex-start', md: 'center' }}
          >
            <Box fontWeight={600} color='gold' fontSize='xl'>
              Immagini
            </Box>
            <Switch
              isChecked={showImages}
              onChange={(e) => setShowImages(e.target.checked)}
              colorScheme='messenger'
              size='lg'
            />
          </HStack>
          <HStack
            w={{ base: '100%', md: 'auto' }}
            justifyContent={'space-between'}
            alignItems={{ base: 'flex-start', md: 'center' }}
          >
            <Box fontWeight={600} color='gold' fontSize='xl'>
              Prezzi
            </Box>
            <Switch
              isChecked={showPrices}
              onChange={(e) => setShowPrices(e.target.checked)}
              colorScheme='messenger'
              size='lg'
            />
          </HStack>
          <HStack
            w={{ base: '100%', md: 'auto' }}
            justifyContent={'space-between'}
            alignItems={{ base: 'flex-start', md: 'center' }}
          >
            <Box fontWeight={600} color='gold' fontSize='xl'>
              Disponibilità
            </Box>
            <Switch
              isChecked={showAvailability}
              onChange={(e) => setShowAvailability(e.target.checked)}
              colorScheme='messenger'
              size='lg'
            />
          </HStack>
        </Stack>
        <HStack w='100%' justifyContent={{ base: 'space-between', md: 'flex-start' }}>
          <Box fontWeight={600} color='gold' fontSize='xl'>
            Colonne
          </Box>
          <Box minW='120px' display='flex' alignItems='center'>
            <Slider
              value={columns}
              onChange={(v) => setColumns(v)}
              min={2}
              max={5}
              step={1}
              flex='1'
              colorScheme='messenger'
              mr={2}
            >
              <SliderTrack>
                <SliderFilledTrack />
              </SliderTrack>
              <SliderThumb />
            </Slider>
            <Box ml={2} fontWeight={700} color='gold' minW='20px' textAlign='center' fontSize='xl'>
              {columns}
            </Box>
          </Box>
        </HStack>
        <HStack w='100%' justifyContent={{ base: 'space-between', md: 'flex-start' }} mt={4} spacing={3}>
          <Button onClick={onOpen}>
            Statistiche
          </Button>
          {appSettings?.cashierOrderHistory == 1 && (
            <Button onClick={onHistoryOpen}>
              Storico Ordini
            </Button>
          )}
        </HStack>
        <ModalCashierStats isOpen={isOpen} onClose={onClose} />
        {appSettings?.cashierOrderHistory == 1 && (
          <ModalOrderHistory isOpen={isHistoryOpen} onClose={onHistoryClose} />
        )}
        <ProductGrid
          products={[...(menu.combos || []), ...menu.products]}
          increment={increment}
          decrement={decrement}
          showImages={showImages}
          showPrices={showPrices}
          showAvailability={showAvailability}
          columns={columns}
        />
      </>
    );
  }

  // CUSTOMER/OPERATOR: accordion classico
  let accordionIndexForSelectedProduct = -1;
  categories.some(function (entry, i) {
    if (!product) {
      accordionIndexForSelectedProduct = -1;
      return false;
    }
    if (entry._cat === product.category) {
      accordionIndexForSelectedProduct = i;
      return true;
    }
  });

  return (
    <Accordion allowMultiple defaultIndex={[accordionIndexForSelectedProduct]}>
      {categories.map((cat, index) => (
        <AccordionItem key={index} borderTop='0px solid red' borderBottom='.1px solid grey'>
          <h2>
            <AccordionButton>
              <Box flex='1' textAlign='left'>
                <Heading my={5} color={'gold'}>
                  {cat.title}
                </Heading>
              </Box>
              <AccordionIcon color='gold' fontSize={'3xl'} />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4}>
            <ProductList products={cat.array} increment={increment} decrement={decrement} />
          </AccordionPanel>
        </AccordionItem>
      ))}
    </Accordion>
  );
}

export default Menu2CategoryAccordion;
